import { useState } from "react";
import "./InternalServerError.css";
import sm_logo from "../assets/img/ruth-icon.png";

const GearSVG = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="white">
    <path d="M43.3 5.5l-3.2 9.7c-2.1.6-4.1 1.5-6 2.6L24.8 13 14 23.8l4.8 9.3c-1.1 1.9-2 3.9-2.6 6L6.5 42.3v15.4l9.7 3.2c.6 2.1 1.5 4.1 2.6 6L14 76.2 24.8 87l9.3-4.8c1.9 1.1 3.9 2 6 2.6l3.2 9.7h15.4l3.2-9.7c2.1-.6 4.1-1.5 6-2.6L76.2 87 87 76.2l-4.8-9.3c1.1-1.9 2-3.9 2.6-6l9.7-3.2V42.3l-9.7-3.2c-.6-2.1-1.5-4.1-2.6-6L87 24.8 76.2 14l-9.3 4.8c-1.9-1.1-3.9-2-6-2.6l-3.2-9.7H43.3zM50 33c9.4 0 17 7.6 17 17s-7.6 17-17 17-17-7.6-17-17 7.6-17 17-17z" />
  </svg>
);

const Stars = () => {
  const stars = Array.from({ length: 80 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    size: Math.random() * 2 + 0.5,
    dur: `${2 + Math.random() * 4}s`,
    delay: `${Math.random() * 6}s`,
    op: 0.3 + Math.random() * 0.5,
  }));

  return (
    <div className="rs-stars">
      {stars.map((s) => (
        <div
          key={s.id}
          className="rs-star"
          style={{
            left: s.left,
            top: s.top,
            width: s.size,
            height: s.size,
            "--dur": s.dur,
            "--delay": s.delay,
            "--op": s.op,
          }}
        />
      ))}
    </div>
  );
};

const StatusRow = ({ icon, label, dotClass, valClass, status }) => (
  <div className="rs-status-row">
    <span className="rs-status-name">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="rgba(255,255,255,0.3)">
        {icon}
      </svg>
      {label}
    </span>
    <span className={`rs-status-val ${valClass}`}>
      <div className={dotClass} />
      {status}
    </span>
  </div>
);

export default function InternalServerError() {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = () => {
    setRetrying(true);
    setTimeout(() => window.location.reload(), 800);
  };

  return (
    <div className="rs-root">
      {/* ── Background ── */}
      <div className="rs-bg">
        <Stars />
        <div className="rs-grid-overlay" />
        <div className="rs-glow rs-glow-red" />
        <div className="rs-glow rs-glow-navy" />
        <div className="rs-glow rs-glow-amber" />
        <div className="rs-scanlines" />
        <div className="rs-flicker" />

        {/* Gears */}
        <div className="rs-gear rs-gear-1">
          <GearSVG size={220} />
        </div>
        <div className="rs-gear rs-gear-2">
          <GearSVG size={160} />
        </div>
        <div className="rs-gear rs-gear-3">
          <GearSVG size={300} />
        </div>

        {/* Lightning bolts */}
        <div className="rs-lightning-wrap">
          <div className="rs-bolt" style={{ left: "15%", "--bur": "7s", "--bdel": "0s" }}>
            <svg width="40" height="300" viewBox="0 0 40 300" fill="none">
              <polyline points="22,0 10,120 24,120 6,300" stroke="rgba(255,200,80,0.7)" strokeWidth="2" strokeLinejoin="round" />
              <polyline points="22,0 10,120 24,120 6,300" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
            </svg>
          </div>
          <div className="rs-bolt" style={{ left: "72%", "--bur": "9s", "--bdel": "3.5s" }}>
            <svg width="30" height="260" viewBox="0 0 30 260" fill="none">
              <polyline points="18,0 8,100 20,100 4,260" stroke="rgba(255,200,80,0.6)" strokeWidth="2" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="rs-bolt" style={{ left: "44%", "--bur": "11s", "--bdel": "6s" }}>
            <svg width="24" height="200" viewBox="0 0 24 200" fill="none">
              <polyline points="14,0 6,80 16,80 3,200" stroke="rgba(255,180,60,0.5)" strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <div className="rs-warning-strip" />
      </div>

      {/* ── Page Content ── */}
      <div className="rs-page">
        {/* Logo */}
        <a href="/dashboard" className="rs-logo">
        <img src={sm_logo} alt="sm-logo" width={"35px"}/>
          <div>
            <div className="rs-logo-name">
              ruth<strong>Shipping</strong>
            </div>
            <span className="rs-logo-tag">Ship Smarter</span>
          </div>
        </a>

        {/* Alert Badge */}
        <div className="rs-alert-badge">
          <div className="rs-alert-dot" />
          Critical Server Error Detected
        </div>

        {/* 500 */}
        <div className="rs-error-num">500</div>

        {/* Decorative Line */}
        <div className="rs-deco-line">
          <div className="rs-deco-cross" />
        </div>

        {/* Heading */}
        <h1 className="rs-error-title">
          Something Went <em>Wrong</em>
        </h1>

        <p className="rs-error-sub">
          Our servers hit an unexpected storm. Our engineering crew has been
          alerted and is working to resolve the issue. Please try again in a
          few moments.
        </p>

        {/* Error Code Chip */}
        <div className="rs-error-code">
          <span className="rs-error-code-label">ERR</span>
          500 · Internal Server Error · HTTP/1.1
        </div>

        {/* Buttons */}
        <div className="rs-btn-group">
          <a href="/dashboard" className="rs-btn-home">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
            Return to Dashboard
          </a>

          <button
            onClick={handleRetry}
            className={`rs-btn-retry${retrying ? " retrying" : ""}`}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
            </svg>
            {retrying ? "Retrying…" : "Try Again"}
          </button>

          <button onClick={() => window.history.back()} className="rs-btn-back">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
            Go Back
          </button>
        </div>


      </div>
    </div>
  );
}